import Head from "next/head";
import Image from "next/image";
import Link from "next/link";


const AppInstall = () => {

  return (
    <div className="font-poppins">
      <Head>
        <style>
          {`
            body {
              background-color: #56D6C7 !important;
            }
          `}
        </style>
      </Head>
      <div className="container py-12">
        <div className="flex justify-center">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/installment/app-install-logo.png"}
            alt="app install Logo"
            quality={100}
            width={80}
            height={80}
          />
        </div>
        <div className="flex justify-center mt-4">
          <Image
            src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/installment/logo-mooimom.png"}
            alt="MOOIMOM Logo"
            quality={100}
            width={330}
            height={500}
            className="w-1/2"
          />
        </div>
        <div className="p-2 mt-12 text-center text-white rounded-lg bg-appInstallBg">
          <p className="mt-4 text-base font-bold">Hello Moms<br />Looking For Another Rewards?</p>
          <p className="mt-4 text-sm">Join our free membership with extra benefits!<br />Sign up free and you automatically become<br />our Silver Member.</p>
          <p className="mt-8 text-base font-bold">DOWNLOAD NOW</p>
          <div className="flex justify-center mt-4">
            <Link href="https://play.google.com/store/apps/details?id=com.mooimom.id" target="_blank">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/installment/google-play.png"}
                alt="Android Store"
                quality={100}
                width={500}
                height={150}
                className="w-[140px]"
              />
            </Link>
          </div>
          <div className="flex justify-center mt-2">
            <Link href="https://apps.apple.com/id/app/mooimom/id1483723655" target="_blank">
              <Image
                src={process.env.NEXT_PUBLIC_STATIC_SITE + "/images/installment/appstore.png"}
                alt="IOS Store"
                quality={100}
                width={500}
                height={150}
                className="w-[140px]"
              />
            </Link>
          </div>
          <p className="my-8 text-xs">MOOIMOM PTE. LTD.</p>
        </div>
      </div>
    </div>
  )
}

export default AppInstall
